module.exports = __webpack_public_path__ + "static/DIY_birdfeeder-57181293eb68277bf78b873d823b42b9.jpg";